module.exports = __webpack_public_path__ + "3800b1065c70929a8308b7320f69d970.png";